import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
export const omitAndDeepEqual = (preProps, props, listProps = []) => {
  const compareProps1 = omit(preProps, listProps);
  const compareProps2 = omit(props, listProps);
  return isEqual(compareProps1, compareProps2);
};
export const pickAndDeepEqual = (preProps, props, listProps = []) => {
  const compareProps1 = pick(preProps, listProps);
  const compareProps2 = pick(props, listProps);
  return isEqual(compareProps1, compareProps2);
};